import Knock from "@knocklabs/client";

export const knockPublicApiKey: string = import.meta.env
	.VITE_VITE_KNOCK_PUBLIC_API_KEY;
export const knockClient = new Knock(knockPublicApiKey as string);
